import { StorageObjectMap } from '../utils/storage/storage.types';

export type AppSessionState = StorageObjectMap['appSession'];

export const initialAppSessionState: AppSessionState | null = null;
